import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, Autoplay } from "swiper/modules";
import { Box } from "@mantine/core";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-cards";
import styles from "@scss/custom-components/custom-testimonials-carousel.module.scss";

interface CustomTestimonialsCarouselProps {
  images: string[];
  autoplay?: boolean;
  autoplayDelay?: number;
  showPagination?: boolean;
}

export const CustomTestimonialsCarousel: React.FC<CustomTestimonialsCarouselProps> = ({
  images,
}) => {
  const swiperRef = useRef<any>(null);

  const hasMultipleBrands = images && images.length > 1;

  const carouselClasses = `testimonials ${styles.carouselContainer}${hasMultipleBrands ? " multi-brands" : " solo-brand"}`;

  return (
    <Box className={carouselClasses}>
      <div className={styles.carouselInner}>
        <Swiper
          ref={swiperRef}
          effect="cards"
          grabCursor={true}
          modules={[EffectCards, Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          className={styles.swiper}
        >
          {images.map((image, index) => (
            <SwiperSlide key={`brand-${index}-slide`} className={styles.swiperSlide}>
              <div className={styles.brandLogo}>
                <img
                  src={image}
                  alt={`Brand ${index + 1}`}
                  className={styles.image}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Box>
  );
};
